import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next'
import cookies from 'js-cookie';
import UserService from '../services/UserService';
import service from '../services/service';
import Datas from '../data/hero/hero-slider.json';
import { Link } from 'react-router-dom';
import "./heroinmagenew.css";
import Carousel from 'react-grid-carousel'
import { ThumbsUp, MonitorPlay } from "lucide-react";
import swal from 'sweetalert';

const languages = [

    {
        code: 'en',
        name: 'English',
        country_code: 'gb',
    },
]

const items = [
    {
        icon: <ThumbsUp size={32} strokeWidth={1.5} />,
        title: "Top Rated Courses",
        description: "NFSU offers online courses for Forensic Sciences"
    },
    {
        icon: <MonitorPlay size={32} strokeWidth={1.5} />,
        title: "Best Training",
        description: "Interactive Training by Experienced Faculty"
    }
];
function HeroImageNew() {

    useEffect(() => {
        UserService.generateToken();
    }, []);

    const currentLanguageCode = cookies.get('i18next') || 'en'
    const currentLanguage = languages.find((l) => l.code === currentLanguageCode)
    const { t } = useTranslation()


    function setError(input, message) {
        const formControl = input.parentElement;
        const errorMsg = formControl.querySelector(".contact_input-msg");
        // formControl.className = "form-control text-left error";
        errorMsg.innerText = message;
    }

    function setSuccess(input) {
        const formControl = input.parentElement;
        // formControl.className = "form-control success";
    }

    function onBlurHandlerName() {
        const name = document.getElementById("contact_name");
        const nameValue = name.value.trim();

        if (nameValue === "") {
            setError(name, t('name_cant_be_blank'));
        }
        else if (nameValue.length < 3) {
            setError(name, t('name_must_be_greater_than_3_characters'));
        }
        else if (nameValue.length > 50) {
            setError(name, t('name_must_be_less_than_50_characters'));
        }
        else if (nameValue.match(/^[A-Za-z ]*$/)) {
            setSuccess(name);
        }
        else {

            setError(name, t('not_a_valid_name'));
        }

    }

    const [getCaptchaModelShow, setCaptchaModelShow] = useState({
        show: false
    })

    const setCaptchaModelHide = () => {
        setCaptchaModelShow({ show: false })
    }

    const submitContactForm = (e) => {
        e.preventDefault();
        setCaptchaModelShow({ show: true })
    }

    const isMobile = (value) => /^[0-9]{10}$/.test(value);

    function isEmail(email) {
        return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(email);
    }

    const [data, setData] = useState();
    const [captchaHash, setCaptchaHash] = useState();
    const [captchaToken, setCaptchaToken] = useState();

    function getCaptchafromService(){

        service.getContactCaptcha()
            .then((res) => {

                setData(res.data.captchaImage);
                setCaptchaHash(res.data.captchaHash);
                setCaptchaToken(res.data.captchaToken);
            })
    }

    useEffect(() => {
        getCaptchafromService();
    }, [])

    const SubmitContactInfo = (e) => {

        e.preventDefault();
        let status = true;
        const name = document.getElementById("contact_name");
        const email = document.getElementById("contact_email");
        const captcha = document.getElementById("contact_captcha");
        const mobile = document.getElementById("mobile_no");
        let contactAuthorize = 0;
        const nameValue = name.value.trim();
        const emailValue = email.value.trim();
        const captchaValue = captcha.value.trim();
        const mobileValue = mobile.value.trim();


        if (mobileValue === "") {
            setError(mobile, "mobile Number is blank");
        } else if (!isMobile(mobileValue)) {
            setError(mobile, "Enter the valid mobile");
        } else {
            setSuccess(mobile);
        }

        if (getAuthorize == true) {
            contactAuthorize = 1;
        }

        if (nameValue === "") {
            setError(name, t('name_cant_be_blank'));
            status = false;
        }
        else if (nameValue.length < 3) {
            setError(name, t('name_must_be_greater_than_3_characters'));
            status = false;
        }
        else if (nameValue.length > 50) {
            setError(name, t('name_must_be_less_than_50_characters'));
            status = false;
        }
        else if (nameValue.match(/^[A-Za-z ]*$/)) {
            setSuccess(name);
        }
        else {

            setError(name, t('not_a_valid_name'));
            status = false;
        }


        if (emailValue === "") {
            setError(email, t('email_cant_be_blank'));
            status = false;
        } else if (!isEmail(emailValue)) {
            setError(email, t('not_a_valid_email'));
            status = false;
        } else {
            setSuccess(email);
        }

        if (status) {
            setLoading(true);
            let conatactBody = {
                emailId: emailValue,
                message: "NA",
                name: nameValue,
                subject: "NA",
                captchaHash: captchaHash,
                captchaInput: captchaInput,
                captchaToken: captchaToken,
                mobileNo: mobileValue,
                contactAuthorize: contactAuthorize
            };

            console.log("conatctBody -> ", conatactBody);

            service.postContactUs(conatactBody)
                .then(async res => {
                    setLoading(false);
                    //console.log(res.status)
                    if (res.status == 201) {
                        await swal(t('thank_you'), t('our_team_will_get_back_to_you_soon'), "success");
                        window.location.reload();
                    }
                })
                .catch(err => {
                    console.log(err.response.status)
                    if (err.response.status === 406) {
                        setError(captcha, t('enter_correct_captcha'));
                        getCaptchafromService();
                    }
                    else if (err.response.status === 404) {
                        setError(captcha, t('invalid_token'));
                        getCaptchafromService();
                    }
                    setLoading(false);
                })

        }

    }

    const [getAuthorize, setAuthorize] = useState(false);

    function handleContactAuthorize() {
        setAuthorize(!getAuthorize);
    }



    const handleRefereshCaptcha = () => {
        service.getContactCaptcha()
            .then((res) => {

                setData(res.data.captchaImage);
                setCaptchaHash(res.data.captchaHash);
                setCaptchaToken(res.data.captchaToken);
            })
    }

    const [captchaInput, setCaptchaInput] = useState();
    const [loading, setLoading] = useState();

    function handleCaptcha(e) {
        setCaptchaInput(e.target.value);
    }


    return (
        <Container fluid className="p-0">

            <Carousel
                cols={1}
                rows={1}
                loop
                showDots
                autoplay={3000}
            >
                {Datas.map((images) => (
                    <Carousel.Item key={images.id}>
                        <div className="hero-card">
                            <div className="hero-image" style={{ margin: "0px", padding: "0px" }}>
                                <img
                                    src={process.env.PUBLIC_URL + `/assets/images/${images.backgroundImage}`}
                                    alt={images.id}
                                />
                            </div>
                        </div>
                    </Carousel.Item>
                ))}
            </Carousel>

            <div className='hero-text'>
                <h4>WORLD'S FIRST AND ONLY <br /> UNIVERSITY DEDICATED TO <br /> FORENSIC SCIENCE</h4>
            </div>
            <div className="contact-form-card">
                {/* <h4>JOIN MANY LEARNERS <br /> ACROSS THE WORLD</h4> */}
                <h4>JOIN MANY LEARNERS ACROSS THE WORLD</h4>
                <p>Submit your details and we’ll contact you soon!</p>

                <form onSubmit={submitContactForm}>
                    <input type="text" placeholder="Full Name" id="contact_name" required minLength={2} maxLength={50} />
                    <input type="text" placeholder="Contact No." id="mobile_no" required maxLength={10} />
                    <input type="email" placeholder="Email ID" id="contact_email" required />

                    <label className="checkbox-text">
                        <input type="checkbox" onClick={handleContactAuthorize} />
                        I authorize National Forensic Sciences University and its associates
                        to contact me with updates/notifications via email, SMS, WhatsApp, and voice call.
                    </label>

                    <button className="submit-btn">Submit</button>
                    {/* <button type="submit" className="submit-btn">Submit</button> */}
                </form>
            </div>
            <div className="features-container">
                {items.map((item, index) => (
                    <div key={index} className="feature-card">
                        <div className="feature-icon">{item.icon}</div>
                        <div className="feature-text">
                            <h5>{item.title}</h5>
                            <p>{item.description}</p>
                        </div>
                    </div>
                ))}
            </div>
            <Modal
                centered show={getCaptchaModelShow.show} onHide={() => setCaptchaModelHide()} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Enter Capcha
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col md="4">
                            <div style={{ marginLeft: "16px", marginTop: "10px" }}>
                                {/* <ClientCaptcha captchaCode={setCode} charsCount={5} /> */}
                                <img src={`data:image/jpeg;base64,${data}`} style={{ height: "50px" }} />
                            </div>
                        </Col>
                        <Col md="2" style={{ marginTop: "10px" }}>
                            <button className='btn' onClick={handleRefereshCaptcha} style={{ color: 'white', fontSize: "24px", background: 'linear-gradient(90deg, #11B67A 0%, #009444 100%)' }}><i class="fa fa-refresh"></i></button>
                        </Col>
                        <Col md="3" style={{ marginTop: "10px" }}>
                            <input type="text" placeholder={t('captcha')} id="contact_captcha" onChange={(e) => handleCaptcha(e)} minLength="4" maxLength="7" />
                            <span className="contact_input-msg"></span>
                        </Col>
                        <Col md="12">
                            {loading ? <button type="button" disabled className="submit-btn"><div class="spinner-border" role="status">
                                <span class="sr-only">{t('loading')}</span>
                            </div>  Submit</button>
                                : <button className="submit-btn" onClick={SubmitContactInfo}>Submit </button>}

                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>

                </Modal.Footer>
            </Modal>

        </Container>


    )

}

export default HeroImageNew
